// The 26 cantons, in the order of the server registry (server/src/services/cantons.py).
// Names are UI text: t(`cantons.${code}`) in it.json.
export const CANTON_CODES = ['ZH', 'BE', 'LU', 'UR', 'SZ', 'OW', 'NW', 'GL', 'ZG', 'FR', 'SO', 'BS', 'BL',
  'SH', 'AR', 'AI', 'SG', 'GR', 'AG', 'TG', 'TI', 'VD', 'VS', 'NE', 'GE', 'JU'] as const

export type CantonCode = typeof CANTON_CODES[number]

export const isCantonCode = (value: unknown): value is CantonCode =>
  typeof value === 'string' && (CANTON_CODES as readonly string[]).includes(value)
